var _ellipse, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeetteamhalfcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1218,
    height: 487,
    viewBox: "0 0 1218 487",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249,
    cy: 243.5,
    rx: 249,
    ry: 243.5,
    fill: "#466D9B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 235,
    width: 983,
    height: 487,
    fill: "#466D9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetteamhalfcircle);
export default __webpack_public_path__ + "static/media/meetteamhalfcircle.950a48896d5ba53c1cea6308843301a2.svg";
export { ForwardRef as ReactComponent };